var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.13636,
    y: -1.13636,
    width: 47.7273,
    height: 47.7273,
    rx: 23.8636,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 1.98688e-07 47.7273)",
    stroke: "#2D5EFF",
    strokeWidth: 2.27273
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7818 23.6264C32.7006 23.6134 32.6185 23.6074 32.5363 23.6085L20.4314 23.6085L20.7365 23.4684C21.0348 23.3292 21.3061 23.1396 21.5384 22.9084L25.4624 19.0368C25.9792 18.55 26.066 17.767 25.6681 17.1815C25.2051 16.5576 24.3171 16.4221 23.6847 16.879C23.6336 16.9159 23.585 16.9562 23.5394 16.9995L16.4436 24.0005C15.889 24.547 15.8885 25.4336 16.4425 25.9807L23.5394 32.9829C24.0944 33.5289 24.9929 33.5277 25.5464 32.9801C25.5899 32.937 25.6306 32.8912 25.6681 32.8429C26.066 32.2574 25.9792 31.4743 25.4624 30.9876L21.5455 27.109C21.3372 26.9033 21.0978 26.7309 20.8359 26.5979L20.4101 26.4089L32.4582 26.4089C33.1832 26.4355 33.8192 25.9358 33.9554 25.2327C34.0809 24.4694 33.5554 23.7502 32.7818 23.6264Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.8b412bde0b3da7df89ee7b6385a8ad16.svg";